import { createSelector } from 'reselect';

import { BASE_INGREDIENTS_CATEGORIES_LIST } from '~constants/customPizza';

const ingredientsSelector = state => state.customPizza?.config?.ingredients || [];

export const baseIngredientsSelector = createSelector(ingredientsSelector, ingredients =>
  Object.values(ingredients).filter(ingredient =>
    BASE_INGREDIENTS_CATEGORIES_LIST.includes(ingredient?.category)
  )
);
